export enum ArtifactLocation  {
    None = 0,
    CloudFlare = 1,
    Vimeo = 2,
}